import * as metaStateUtils from '../../../../store/util/metaStateUtils';


/**
 * Builds a region -> subRegion -> country hierarch
 *
 * @param countries {array|object[]} List of countries
 * @return {{}} Region hierarchy
 */
const buildRegionHierarchy = countries => {

    const regionByCode = {};
    countries.forEach(country => {

        const {alpha2, region, regionCode, subRegion, subRegionCode} = country;
        const regionData = regionByCode[regionCode] || {
            region,
            regionCode,
            subRegionByCode: {}
        };
        const subRegionData = regionData.subRegionByCode[subRegionCode] || {
            subRegion,
            subRegionCode,
            countries: {}
        };
        subRegionData.countries[alpha2] = country;
        regionData.subRegionByCode[subRegionCode] = subRegionData;

        regionByCode[regionCode] = regionData;
    });

    return regionByCode;
};


/**
 * @param state {object} Domain state
 * @param geoConfigState {object} Geo configuration
 * @param isLoading {boolean} True marks loading, false as loaded
 * @return {object} Updated domain state
 */
export default (state, geoConfigState, isLoading) => {

    state.geo = isLoading
        ? metaStateUtils.setIsLoading({...geoConfigState})
        : metaStateUtils.setIsLoaded({...geoConfigState});

    if (!isLoading) {
        state.geo.regionByCode = buildRegionHierarchy(geoConfigState.countries);
    }

    return state;
};
